import * as yup from 'yup';

export const loginSchema = yup.object({
  identifier: yup
    .string()
    .trim()
    .required('Email or username is required')
    .test(
      'email-or-username',
      'Enter a valid email or a username (3+ characters: letters, numbers, underscores only)',
      (value) => {
        if (!value) return false;
        if (value.includes('@')) {
          return yup.string().email().isValidSync(value);
        }
        return /^[a-zA-Z0-9_]{3,}$/.test(value);
      }
    ),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters'),
});

export const loginDefaultValues = {
  identifier: '',
  password: '',
};

// // src/components/forms/LoginForm/validation.js
// import * as yup from 'yup';

// export const loginSchema = yup.object({
//   identifier: yup
//     .string()
//     .required('Email is required') // Updated message since backend expects email
//     .email('Please enter a valid email address'), // Add email validation
//   password: yup
//     .string()
//     .required('Password is required')
//     .min(6, 'Password must be at least 6 characters'), // Match backend minimum
// });

// // Default values for forms
// export const loginDefaultValues = {
//   identifier: '',
//   password: '',
// };


// import * as yup from 'yup';

// export const loginSchema = yup.object({
//   identifier: yup
//     .string()
//     .required('Username or email is required')
//     .min(3, 'Must be at least 3 characters'),
//   password: yup
//     .string()
//     .required('Password is required')
//     .min(8, 'Password must be at least 8 characters'),
// });



// // Default values for forms
// export const loginDefaultValues = {
//   identifier: '',
//   password: '',
// };